import { gql } from '@apollo/client';
import ORGANIZATION_BILLING_FRAGMENT from './OrganizationBilling';
import USER_AVATAR_FRAGMENT from './UserAvatar';
import USER_SETTINGS_FIELDS_FRAGMENT from './UserSettingsFields';

export default gql`
  fragment CurrentSession on Session {
    authToken
    intercomHash
    organization {
      id
      insertedAt
      logo {
        thumb
      }
      name
      email
      host
      effectiveHost
      isVerified
      settings {
        authentication
        seatLimit
      }
      ...OrganizationBilling
    }
    user {
      id
      email
      name
      title
      description
      type
      insertedAt
      ...UserAvatar
      membershipGroups {
        id
      }
      settings {
        ...UserSettingsFields
      }
      identities {
        id
        platform
      }
    }
  }

  ${ORGANIZATION_BILLING_FRAGMENT}
  ${USER_AVATAR_FRAGMENT}
  ${USER_SETTINGS_FIELDS_FRAGMENT}
`;
